import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Modals } from 'app/shared/constants/modals';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { Company } from 'app/shared/models/company.model';
import { CompanyService } from 'app/shared/services/company.service';
import { SectionService } from 'app/shared/services/section.service';
import { Utils } from 'app/shared/utils/utils';
import { PaginationService } from 'ngx-pagination';
import { format } from 'util';

@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class CompaniesListComponent extends ListBaseComponent implements OnInit {

  fieldCollection = [
    {name: 'IsActive', displayName: 'companies.isActiveFieldTitle', canSort: true, displayClass: ''},
    {
      name: 'CompanyId',
      displayName: 'companies.companyIdFieldTitle',
      canSort: true,
      displayClass: 'd-none d-lg-table-cell'
    },
    {name: 'Name', displayName: 'companies.nameFieldTitle', canSort: true, displayClass: ''},
    {name: 'IBAN', displayName: 'companies.iBANFieldTitle', canSort: true, displayClass: 'd-none d-lg-table-cell'},
    {
      name: 'CreditAmount',
      displayName: 'companies.creditAmountFieldTitle',
      canSort: true,
      displayClass: 'd-none d-sm-table-cell'
    },
    {
      name: 'company.OnboardingStatus.IconClass',
      displayName: 'companies.onboardingFieldTitle',
      canSort: false,
      displayClass: ''
    }
  ];

  private confirmDeactivateCompanyMessage: string;
  private companyActivatedMessage: string;
  private companyDeactivatedMessage: string;

  get hasFinancialTransactionsViewPermission(): boolean {
    return this.hasPermission(Permissions.Companies_FinancialTransactions_View);
  }

  constructor(protected sectionService: SectionService, protected companyService: CompanyService, protected modalService: NgbModal, private router: Router,
              protected translateService: TranslateService) {
    super(sectionService, Sections.Companies, modalService, Modals.CompanyComponent);
  }

  ngOnInit(): void {
    super.initializeView(Constants.Companies_List_DefaultSortField, Constants.Companies_List_DefaultSortDirectionAscending);
    this.translateService.get(['companies.confirmDeactivateCompanyMessage', 'companies.companyActivatedMessage', 'companies.companyDeactivatedMessage'])
      .subscribe(translations => {
        this.confirmDeactivateCompanyMessage = translations['companies.confirmDeactivateCompanyMessage'];
        this.companyActivatedMessage = translations['companies.companyActivatedMessage'];
        this.companyDeactivatedMessage = translations['companies.companyDeactivatedMessage'];
      });
  }

  handleBooleanToggleFilterChanged(newValue: boolean): void {
    this.filterBase.ShowActiveAndInActiveItems = newValue;
    this.getCollection();
  }

  openOnboardingUrlButtonDisabled(company: Company): boolean {
    return Utils.isStringNullOrWhiteSpace(company.IbanXSOnboardingUrl);
  }

  openOnboardingUrl(company: Company): void {
    window.open(company.IbanXSOnboardingUrl, '_blank');
  }

  viewFinancialTransactions(company: Company): void {
    this.router.navigate(['/financial-transactions'], {
      queryParams: {
        companyId: company.CompanyId,
        companyName: company.Name,
        companyCreditAmount: company.CreditAmountCurrency
      }
    });
  }

  activate(company: Company): void {
    this.companyService.activateNow('/company/activate/' + company.CompanyId, () => this.getCollection(), this.companyActivatedMessage);
  }

  deactivate(company: Company): void {
    if (confirm(format(this.confirmDeactivateCompanyMessage, company.Name))) {
      this.companyService.deactivateNow('/company/deactivate/' + company.CompanyId, () => this.getCollection(), this.companyDeactivatedMessage);
    }
  }

  getCollection(pageNumber: number = 1): void {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.companyService.getCollectionPaginated<Company>(
      '/company',
      this.pageConfiguration,
      this.filterBase,
      (collection) => {
        this.collection = collection;
      }
    );
  }
}
